import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=1600f516&"
import script from "./personal-data.vue?vue&type=script&lang=js&"
export * from "./personal-data.vue?vue&type=script&lang=js&"
import style0 from "./personal-data.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports